export default __webpack_public_path__ + "static/media/buildings_old.895cf40d.png";